<template>
  <div>
    <media-card-image
      v-if="
        media.mediaTypeId === mediaTypesEnum.poi_image ||
          media.mediaTypeId === mediaTypesEnum.menu_item_image ||
          media.mediaTypeId === mediaTypesEnum.poi_image_dzi ||
          media.mediaTypeId === mediaTypesEnum.project_title_image ||
          media.mediaTypeId === 0
      "
      :hideActions="hideActions"
      :gridView="isGridView"
      :media="media"
      :checked="checked"
      :showCheckbox="showCheckbox"
      :orderable="orderable"
      :orderControlsDisabled="orderControlsDisabled"
      @changeChecked="$emit('changeChecked', $event)"
      @edit="$emit('edit', $event)"
      @AddToGallery="openAddToGalleryDialog()"
      @deleted="$emit('deleted', $event)"
      @orderChange="$emit('orderChange', $event)"
    ></media-card-image>
    <media-card-description
      v-else-if="
        media.mediaTypeId === mediaTypesEnum.description ||
          media.mediaTypeId === mediaTypesEnum.project_text_description
      "
      :hideActions="hideActions"
      :gridView="isGridView"
      :media="media"
      :checked="checked"
      :showCheckbox="showCheckbox"
      @changeChecked="$emit('changeChecked', $event)"
      @edit="$emit('edit', $event)"
      @deleted="$emit('deleted', $event)"
    ></media-card-description>
    <media-card-poi-title
      v-else-if="
        media.mediaTypeId === mediaTypesEnum.poi_title ||
          media.mediaTypeId === mediaTypesEnum.menu_item_title ||
          media.mediaTypeId === mediaTypesEnum.project_title
      "
      :hideActions="hideActions"
      :gridView="isGridView"
      :media="media"
      :checked="checked"
      :showCheckbox="showCheckbox"
      @changeChecked="$emit('changeChecked', $event)"
      @edit="$emit('edit', $event)"
      @deleted="$emit('deleted', $event)"
    ></media-card-poi-title>
    <media-card-unity-component
      v-else-if="
        media.mediaTypeId === mediaTypesEnum.unity_serialize_component ||
          media.mediaTypeId === mediaTypesEnum.unity_link_component ||
          media.mediaTypeId === mediaTypesEnum.unity_language_config
      "
      :gridView="isGridView"
      :media="media"
      @edit="$emit('edit', $event)"
      @deleted="onDeleted()"
    ></media-card-unity-component>
    <media-card-poi-data
      v-else-if="media.mediaTypeId === mediaTypesEnum.poi_data"
      :gridView="isGridView"
      :media="media"
      :checked="checked"
      :showCheckbox="showCheckbox"
      @changeChecked="$emit('changeChecked', $event)"
      @edit="$emit('edit', $event)"
      @deleted="$emit('deleted', $event)"
    ></media-card-poi-data>
    <media-card-gallery
      v-else-if="media.mediaTypeId === mediaTypesEnum.media_gallery"
      :gridView="isGridView"
      :media="media"
      @edit="onEdit()"
      @deleted="onDeleted()"
    ></media-card-gallery>
    <media-card-menu-item-data
      v-else-if="media.mediaTypeId === mediaTypesEnum.menu_item_data"
      :gridView="isGridView"
      :media="media"
      @edit="onEdit()"
      @deleted="onDeleted()"
    ></media-card-menu-item-data>
  </div>
</template>

<script>
import Enums from '../../helpers/Enums'
import MediaCardImage from './MediaCardImage'
import MediaCardDescription from './MediaCardDescription'
import MediaCardPoiTitle from './MediaCardPoiTitle'
import MediaCardUnityComponent from './MediaCardUnityComponent'
import MediaCardPoiData from './MediaCardPoiData'
import MediaCardGallery from './MediaCardGallery'
import MediaCardMenuItemData from './MediaCardMenuItemData'

export default {
  components: {
    MediaCardPoiData,
    MediaCardImage,
    MediaCardDescription,
    MediaCardPoiTitle,
    MediaCardUnityComponent,
    MediaCardGallery,
    MediaCardMenuItemData
  },
  props: {
    media: {
      type: Object,
      required: true,
      default: function() {
        return {}
      }
    },
    selected: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    isGridView: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    showCheckbox: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    checked: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    hideActions: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    orderable: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    orderControlsDisabled: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    }
  },

  created: function() {
    this.mediaTypesEnum = Enums.MediaType
  },
  computed: {},
  methods: {
    onEdit() {
      this.$emit('edit')
    },
    openAddToGalleryDialog: async function() {
      await this.$store.dispatch(
        'MediaStore/setSelectedMediaItem',
        this.media.id
      )
      this.$emit('AddToGallery')
    },
    onDeleted: function() {
      this.$emit('deleted')
    }
  },
  data: function() {
    return {}
  }
}
</script>

<style scoped>
.selected {
  border: 4px solid #2196f3;
  border-radius: 10px;
  box-sizing: border-box;
}
</style>
